import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ChangeOrderPayload } from 'src/app/model/order-details.model';
import { environment } from 'src/environments/environment';
import { BaseSiteConfigService } from '../base-site/base-site-config.service';
import { ComponentService } from '../component.service';
import { MyAccountPermissionService } from './my-account-permission.service';

@Injectable({
  providedIn: 'root',
})
export class OrderDetailsService {
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  order$: Observable<Order>;
  OrderDetailsIsStable = false;
  orderDetailsFieldsParams: any[] = [];

  constructor(
    protected http: HttpClient,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    private meta: Meta,
    private componentService: ComponentService,
    private myAccountPermissionService: MyAccountPermissionService,
    protected baseSiteConfigService: BaseSiteConfigService
  ) {}

  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get tokenId(): string {
    let tokenId: string;
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe((tokenIdData) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  setOrderDetailsFieldsParams(): any[] {
    this.orderDetailsFieldsParams = [];
    this.myAccountPermissionService.currentUserPermissions$.subscribe((data) => {
      if (data) {
        this.orderDetailsFieldsParams = [
          'createdDateString',
          'orderType',
          'placedBy',
          'purchaseOrderNumber',
          'statusDisplay',
          'deliverFullOrder',
          'totalPrice(FULL)',
          'subTotal(FULL)',
          'orderDiscounts(FULL)',
          'deliveryCost(FULL)',
          'code',
          'statusCode',
          'consignments(FULL)',
          'paymentInfoDetails(FULL)',
          'totalTax(FULL)',
          'erpOrderNumber',
          'freeShipping',
          'holdCode',
          'erpOrderType',
          'orderTypeCode',
        ];
      } else {
        this.orderDetailsFieldsParams = [
          'createdDateString',
          'orderType',
          'placedBy',
          'purchaseOrderNumber',
          'statusDisplay',
          'deliverFullOrder',
          'totalPrice(FULL)',
          'subTotal(FULL)',
          'orderDiscounts(FULL)',
          'deliveryCost(FULL)',
          'code',
          'statusCode',
          'consignments(FULL)',
          'paymentInfoDetails(FULL)',
          'totalTax(FULL)',
          'erpOrderNumber',
          'orderTypeCode',
        ];
      }
    });
    return this.orderDetailsFieldsParams;
  }

  getOrderDetails(code: string, erpOrderType: string = null): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('fields', this.setOrderDetailsFieldsParams().join());

    if (erpOrderType) {
      httpParams = httpParams.append('erpOrderType', erpOrderType);
    }

    const httpOptions = {
      headers: this.headers,
      observe: 'body' as 'response',
      params: httpParams,
    };

    return this.http
      .post(`${this.url}/users/${this.userCurrent}/${code}/details`, null, httpOptions)
      .pipe(catchError((error: any) => throwError(error)));
  }

  getOrderHistoryConfig(): Observable<any> {
    return this.http
      .get(`../../../public/features/ORDER_HISTORY_FEATURES.json`)
      .pipe(catchError((error: any) => throwError(error)));
  }

  getCancelOrderReasons(): Observable<any> {
    return this.http.get(`${this.url}/users/${this.userCurrent}/cancelOrder/reasons`).pipe(
      map((data: any) => data),
      catchError((error: any) => throwError(error))
    );
  }

  submitChangeOrder(payload: ChangeOrderPayload): Observable<any> {
    return this.http
      .post(`${this.url}/users/${this.userCurrent}/changeOrder`, payload, {
        headers: this.headers,
      })
      .pipe(
        map((data: any) => {
          if (!data.code) {
            throw new Error('rejected');
          } else {
            return data;
          }
        }),
        catchError((error: any) => throwError(error))
      );
  }

  getOrderDetailsHideDiscount$(): Observable<any> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.order.details.hide.discount'])
      .pipe(map((configs) => configs && configs.map((res: any) => res.value === 'true')[0]));
  }
}
